import React from "react";
import { CssBaseline } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import Signin from "./pages/Signin";
import Signup from "./pages/Signup";
import Forgot from "./pages/Forgot";

function App() {
  return (
    <>
      <CssBaseline />
      <Routes>
          <Route path="/login" element={<Signin />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/password-forgot" element={<Forgot />} />
      </Routes>
    </>
  );
}

export default App;
